import React, { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import UserContext from "./UserContext";
import PaymentConfigPanel from "./PaymentConfigPanel";
import PaymentRoutingAdminPanel from "./PaymentRoutingAdminPanel";
import ValetApi from "../api/Api";
import "./UserConfig.css";

const PaymentPricingConfigPage = () => {
    const { userDetail } = useContext(UserContext);
    const roleId = Number(userDetail?.roleId || 0);
    const isAdmin = roleId >= 5;
    const [featureEnabled, setFeatureEnabled] = useState(null);
    const [isFeatureLoading, setIsFeatureLoading] = useState(false);

    useEffect(() => {
        let isMounted = true;

        async function fetchFeatureStatus() {
            if (!userDetail || roleId < 3) return;

            try {
                setIsFeatureLoading(true);
                const res = await ValetApi.getPaymentsFeatureStatus();
                if (isMounted) {
                    setFeatureEnabled(Boolean(res?.data?.featureEnabled));
                }
            } catch {
                if (isMounted) {
                    setFeatureEnabled(null);
                }
            } finally {
                if (isMounted) {
                    setIsFeatureLoading(false);
                }
            }
        }

        fetchFeatureStatus();

        return () => {
            isMounted = false;
        };
    }, [userDetail, roleId]);

    if (!userDetail) {
        return (
            <section className="page-scroll">
                <div className="page-scroll-inner admin-config-page">
                    <h2>Payment Pricing Configuration</h2>
                    <p>Loading user permissions...</p>
                </div>
            </section>
        );
    }

    if (roleId < 3) {
        return (
            <section className="page-scroll">
                <div className="page-scroll-inner admin-config-page">
                    <h2>Payment Pricing Configuration</h2>
                    <p>Manager access required.</p>
                </div>
            </section>
        );
    }

    const shouldHidePaymentSetup = featureEnabled === false && !isAdmin;

    return (
        <section className="page-scroll">
            <div className="page-scroll-inner admin-config-page">
                <div className="payment-feature-header">
                    <h2>Payment Pricing Configuration</h2>
                    <span className={`payment-feature-badge ${featureEnabled === true ? "is-on" : featureEnabled === false ? "is-off" : "is-unknown"}`}>{isFeatureLoading ? "Feature: Checking..." : featureEnabled === true ? "Feature: ON" : featureEnabled === false ? "Feature: OFF" : "Feature: Unknown"}</span>
                </div>
                <div className="payment-config-nav-row">
                    {!shouldHidePaymentSetup ? (
                        <Link
                            to="/payments/reports"
                            className="payment-config-report-link">
                            Open Payment Reports
                        </Link>
                    ) : null}
                    <Link
                        to="/validations/tenants"
                        className="payment-config-report-link">
                        Validation Setup
                    </Link>
                    <Link
                        to="/validations/redeem"
                        className="payment-config-report-link">
                        Validation Redeem
                    </Link>
                    <Link
                        to="/validations/reports"
                        className="payment-config-report-link">
                        Validation Reports
                    </Link>
                </div>
                {shouldHidePaymentSetup ? (
                    <div className="admin-section admin-section-payment-config">
                        <p>Payments are disabled in this environment. Payment setup is visible to Admin users only.</p>
                    </div>
                ) : (
                    <>
                        <div className="admin-section admin-section-payment-config">
                            <PaymentConfigPanel />
                        </div>
                        <div className="admin-section admin-section-payment-routing">
                            <PaymentRoutingAdminPanel />
                        </div>
                    </>
                )}
            </div>
        </section>
    );
};

export default PaymentPricingConfigPage;
